<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQSport',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Eventi Sportivi", link : 'conv-bitq-sport' } ],

        // Nome welfarebit del servizio
        service_title : "Eventi Sportivi",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 14
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>